export default __webpack_public_path__ + "static/media/light-bottom-desktop.9cbe2c21.webp";